import { Grid } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { DISCOVER_BOOKING_ROUTE } from "../constants";

const ChangePaymentMethodBanner = ({ bookingId }) => {
  const { t } = useTranslation();

  const hereText = t('booking.paymentInfo.here');
  const changePaymentMethodLink = `${DISCOVER_BOOKING_ROUTE}/change-payment-method/${bookingId}`

  return (
    <>
      <Grid item xs={12} lg={10}>
        <Alert severity="warning" variant="outlined">
          <Trans
            i18nKey="booking.paymentInfo.toChangePaymentDetails"
            values={{ hereText }}
            components={{
              1: <a target="_blank" href={changePaymentMethodLink} style={{ textDecoration: 'underline' }}>{hereText}</a>,
            }}
          />
        </Alert>
      </Grid>
    </>
  )
}

export default ChangePaymentMethodBanner;
